<template>
  <v-dialog max-width="1200px" v-model="inDialog" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('lang.school.className')"
                  v-model.trim="item.className"
                  name="className"
                  v-validate="'required'"
                  maxLength="500"
                  :error-messages="errors.first('className')"
                  :data-vv-as="$t('lang.school.className')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-autocomplete
                  :items="ages"
                  :label="$t('lang.school.ageId')"
                  v-model="item.ageId"
                  name="ageId"
                  item-value="categoryId"
                  item-text="categoryName"
                  v-validate="'required'"
                  :data-vv-as="$t('lang.school.ageId')"
                  :error-messages="errors.first('ageId')"
              />
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('lang.school.classAccount')"
                  v-model.trim="item.classAccount"
                  name="classAccount"
                  v-validate="'required'"
                  maxLength="500"
                  :error-messages="errors.first('classAccount')"
                  :data-vv-as="$t('lang.school.classAccount')"
              ></v-text-field>
            </v-flex>
            <v-flex xs5 sm5 md5 lg5 xl5 style="padding: 10px">
              <v-text-field
                  :type="showPassword ? 'text' : 'password'"
                  :label="$t('lang.school.classPassword')"
                  v-model.trim="item.classPassword"
                  name="classPassword"
                  v-validate="'required'"
                  maxLength="500"
                  :error-messages="errors.first('classPassword')"
                  :data-vv-as="$t('lang.school.classPassword')"
              >

              </v-text-field>

            </v-flex>
            <v-flex xs61 sm1 md1 lg1 xl1 style="padding: 10px">
              <v-btn icon @click="showPassword = !showPassword">
                <v-icon>{{ showPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-autocomplete
                  :items="levelStarts"
                  :label="$t('lang.school.levelStartId')"
                  v-model="item.levelStartId"
                  name="levelStartId"
                  item-value="categoryId"
                  item-text="categoryName"
                  v-validate="'required'"
                  :data-vv-as="$t('lang.school.levelStartId')"
                  :error-messages="errors.first('levelStartId')"
              />
            </v-flex>
            <v-flex xs5 sm5 md5 lg5 xl5 style="padding: 10px">
              <v-text-field
                  :type="text"
                  :label="$t('lang.school.numberStudent')"
                  v-model.trim="item.numberStudent"
                  name="numberStudent"
                  v-validate="'required|numeric'"
                  maxLength="500"
                  :error-messages="errors.first('numberStudent')"
                  :data-vv-as="$t('lang.school.numberStudent')"
              >

              </v-text-field>

            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../../services";
import axios from "axios";
import {areaContants} from "@/constants";
import moment from "moment/moment";

export default {
  name: "school-create-form",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },


  },
  data: () => {
    return {
      areaStatus: areaContants.areaStatus,
      item: {
        className: "",
        ageId: "",
        product: ""
      },
      inDialog: false,
      showPassword: false,
      ages: {
        type: Array,
        default: () => {
          return []
        }
      },
      levelStarts: {
        type: Array,
        default: () => {
          return []
        }
      },
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        if (value !== null) {
          this.item =  Object.assign({}, value);
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    resetFrom: function () {
      const domain = window.location.hostname;
      const product = domain.includes("lms-edusmart.") ? "EDUSMART" : "BABILALA";
      this.item = Object.assign({}, {"isActive": 1, product: product});
    },

    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        const domain = window.location.hostname;
        const product = domain.includes("lms-edusmart.") ? "EDUSMART" : "BABILALA";
        this.item.product = product;

        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/schoolClass/save",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {
                    let msg = data.description;
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },

  },
  created() {
    axios.post(
        process.env.VUE_APP_API_URL + "/category/onSearch?categoryTypeCode=SCHOOL_AGE&pageSize=-1&page=-1", {status: 1}
    ).then((data) => {this.ages = data.items;
     });
    axios.post(
        process.env.VUE_APP_API_URL + "/category/onSearch?categoryTypeCode=SCHOOL_LEVEL_START&pageSize=-1&page=-1", {status: 1}
    ).then((data) => {this.levelStarts = data.items;
    });


  },
};
</script>
